import {useEffect} from 'react'
import {useNavigate, useParams} from 'react-router-dom'

const EditRequestPage = () => {
  const {editRequestId} = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (editRequestId) {
      // Reuse the exact same UI/component as product edit by redirecting with the legacy param shape
      navigate(`/products/product-edit/${editRequestId}&edit`, {replace: true})
    }
  }, [editRequestId, navigate])

  return null
}

export default EditRequestPage
